module.exports = __webpack_public_path__ + "img/15.52fe9299.png";